document.addEventListener("DOMContentLoaded", function () {
  const progress = document.getElementById("cbp-progress");
  const content = document.getElementById("cbp-content");
  const tocList = document.getElementById("cbp-toc-list");

  if (progress) {
    window.addEventListener("scroll", function () {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const percent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      progress.style.width = percent + "%";
    });
  }

  if (content && tocList) {
    const headings = content.querySelectorAll("h2, h3");

    if (headings.length === 0) {
      tocList.closest(".cbp-toc").style.display = "none";
      return;
    }

    headings.forEach(function (heading, index) {
      const id = "cbp-heading-" + index;
      heading.setAttribute("id", id);

      const link = document.createElement("a");
      link.href = "#" + id;
      link.textContent = heading.textContent;

      if (heading.tagName.toLowerCase() === "h3") {
        link.style.paddingLeft = "18px";
      }

      tocList.appendChild(link);
    });
  }
});